import type { SecondaryMarketPriceType } from 'api/data-contracts';
import { connect } from 'react-redux';
import type { FormOwnProps } from 'shared/connect/connect';
import { limitOrderSelectors } from 'state/secondaryMarket/limit-order/limitOrder.selector';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import { limitOrderReferentialSelectors } from 'state/secondaryMarket/limit-order/referential/referential.selector';
import type { StreamingPriceForDisplay } from 'state/secondaryMarket/realtime/realtime.selector';
import type { ThunkDispatch } from 'state/state.common';
import type { AppState } from 'state/state.model';
import type { SecondaryWorkspaceType } from 'state/workspaces/model';
import { getTabIsFrozen } from 'state/workspaces/tabs/tabs.selector';

type LimitSectionStateProps = {
  clientLimit?: number;
  salesMarginAdjustment?: number;
  price?: number;
  salesMargin?: number;
  isFrozen: boolean;
  priceType: SecondaryMarketPriceType;
  currency: string;
  streamingPrice?: StreamingPriceForDisplay;
};

type LimitSectionDispatchProps = {
  clientLimitChanged: (limit?: number) => void;
  salesMarginAdjustmentChanged: (salesMargin?: number) => void;
};

type LimitSectionOwnProps = FormOwnProps & {
  className?: string;
  workspace: SecondaryWorkspaceType;
};
export type LimitSectionProps = LimitSectionStateProps & LimitSectionDispatchProps & LimitSectionOwnProps;
const mapStateToProps = (state: AppState, { formId, workspace }: LimitSectionOwnProps): LimitSectionStateProps => {
  return {
    clientLimit: limitOrderSelectors.getLimit(state, formId),
    salesMarginAdjustment: limitOrderSelectors.getSalesMarginAdjustment(state, formId),
    isFrozen: getTabIsFrozen(state, formId) ?? false,
    currency: limitOrderReferentialSelectors.getCurrency(state, formId)!,
    priceType: limitOrderReferentialSelectors.getPriceType(state, formId)!,
    streamingPrice: limitOrderSelectors.getStreamingPriceForDisplay(state, formId, workspace),
  };
};

const mapDispatchToProps = (
  dispatch: ThunkDispatch,
  { formId: tabId }: LimitSectionOwnProps,
): LimitSectionDispatchProps => {
  return {
    clientLimitChanged(limit) {
      dispatch(limitOrderThunks.clientLimitChangedThunks(tabId, limit));
    },
    salesMarginAdjustmentChanged(salesMargin) {
      dispatch(limitOrderThunks.salesMarginAdjustmentChangedThunks(tabId, salesMargin));
    },
  };
};

export const connectLimitSection = connect(mapStateToProps, mapDispatchToProps);
